import { Button, Col, Row } from "antd"
import React, { useContext, useEffect, useState } from "react"
import pattern from "../../assets/icons/actions/pattern.svg"
import Filter from "../../components/device/Filter"
import List from "../../components/device/List"
import { AuthContext } from "../../context/auth"
import api from "../../services/api"
import { Translate } from "../../translate"
import { messageError } from "../../util/messages"

const Device = () => {

    const { environment, searchItemId } = useContext(AuthContext)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [pagination, setPagination] = useState({})
    const [params, setParams] = useState({ page: 0, rowPerPage: 5, enabled: true, order: "desc" })
    const [open, setOpen] = useState(false)
    const [item, setItem] = useState()

    const handleNew = () => {
        setOpen(true)
        setItem({ enabled: true, deleted: false })
    }


    const search = (values) => {
        setLoading(true)
        let _params = {
            ...params,
            ...values || {}
        }
        setParams(_params)
        api.get("/control/device/", { params: _params })
            .then((response) => {
                setData(response.data.content)
                setPagination({
                    current: response.data.number + 1,
                    pageSize: response.data.size,
                    total: response.data.totalElements,
                    showSizeChanger: true
                })
            })
            .catch((error) => {
                messageError(error)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        if (searchItemId)
            search({ id: searchItemId, page: 0, rowPerPage: 5, enabled: undefined, order: "desc" })
    }, [searchItemId])


    return (
        <>
            <Row>

                <Col xs={24} className="space-botton">
                    <span className="text-title primary-text-color" >{Translate.t("menu.device")}</span>
                </Col>
                <Col xs={18} sm={16} md={14} lg={12} className="space-botton">
                    <span className="text-sub secondary-text-color" >{Translate.t("title.info.device")}</span>
                </Col>
                <Col xs={6} sm={8} md={10} lg={12} className="alng-rigth space-botton">
                    <Button type={"primary"} icon={<img className="btn-img-icon" src={pattern} alt="device" />} onClick={handleNew} title={Translate.t("action.new", { name: Translate.t("device.title") })} >
                        <span className="no-mobile">{Translate.t("action.new", { name: Translate.t("device.title") })}</span>
                    </Button>
                </Col>
            </Row>
            <Filter
                search={search}
                loading={loading}
            />
            <List
                search={search}
                pagination={pagination}
                data={data}
                loading={loading}
                open={open}
                setOpen={setOpen}
                item={item}
                setItem={setItem}
            />
        </>
    )
}

export default Device